import { CellData, CellUtil } from '@ddt-web/data-service';
import * as get from 'lodash/get';

import { IHighChartsAttributesModel } from '../../models/high-charts-attributes.interface';
import { BaseChartWorker } from '../common';

/**
 * InsightEmergingMarketChartWorker: chart worker specific to a Insight Multi Column Chart.
 * @param {any} config JSON object representing the chart configuration.
 * @param {IHighChartsAttributesModel} highChartsAttributes an object containing properties used to augment the chart configuration.
 */
export class InsightEmergingMarketChartWorker extends BaseChartWorker {
	constructor(config: any, highChartsAttributes: IHighChartsAttributesModel) {
		super(config, highChartsAttributes);
		if (this.highChartsAttributes.isPdf) {
			this.initChartForPdf();
		}
	}

	private initChartForPdf(): void {
		this.config.chart.height = this.highChartsAttributes.height;
		this.config.chart.width = this.highChartsAttributes.width;
	}
	public transformData(): void {
		const cells = get(this.highChartsAttributes.tabData, `tableData[0].cells[${this.highChartsAttributes.portfolioIndex}]`);
		const cohortEmergingMarketCell = CellUtil.getById<CellData>(cells, 'cohortEmergingMarketWeight');
		const emergingMarketCell = CellUtil.getById<CellData>(cells, 'emergingMarketWeight');
		const headersX = get(this.highChartsAttributes.tabData, `tableData[0].headersX`);
		if (headersX && cohortEmergingMarketCell && emergingMarketCell) {
			const cohortEmergingMarketIndex = CellUtil.getIndex(cells, 'cohortEmergingMarketWeight');
			const emergingMarketIndex = CellUtil.getIndex(cells, 'emergingMarketWeight');
			this.config.series.push({ name: headersX[cohortEmergingMarketIndex].formattedValue, data: [cohortEmergingMarketCell.rawValue] });
			this.config.series.push({ name: headersX[emergingMarketIndex].formattedValue, data: [emergingMarketCell.rawValue] });
		}
	}
}

